import { TrendingUp, TrendingDown } from "react-feather";
import useVendorDashboard from "../../hooks/useVendorDashboard";
import VendorTopCustomersChart from "../../Chart/VendorTopCustomersChart";
import VendorTopProductsChart from "../../Chart/VendorTopProductsChart";
import { useNavigate } from "react-router-dom";

export default function venDashboard() {
  const { data, isLoading, isError } = useVendorDashboard();
  const navigate = useNavigate();
  if (isLoading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: 300 }}
      >
        <div className="spinner-border text-primary"></div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="text-danger text-center">Failed to load dashboard</div>
    );
  }

  return (
    <div className="container-fluid">
      <div className="row">
        {/* TOTAL ORDERS */}
        <div className="col-sm-6 col-xxl-3 col-lg-6">
          <div
            className="main-tiles border-5 card-hover border-0 card o-hidden"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/orders")}
          >
            <div className="custome-2-bg b-r-4 card-body">
              <div className="media static-top-widget">
                <div className="media-body p-0">
                  <span className="m-0">Total Orders</span>
                  <h4 className="mb-0 counter">
                    {isLoading ? (
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : isError ? (
                      "0"
                    ) : (
                      data.total_orders
                    )}
                    <TrendingDown size={8.5} />
                  </h4>
                </div>
                <div className="align-self-center text-center">
                  <i className="ri-shopping-bag-3-line"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* TOTAL PRODUCTS */}
        <div className="col-sm-6 col-xxl-3 col-lg-6">
          <div
            className="main-tiles border-5 card-hover border-0  card o-hidden"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/product")}
          >
            <div className="custome-3-bg b-r-4 card-body">
              <div className="media static-top-widget">
                <div className="media-body p-0">
                  <span className="m-0">Total Products</span>
                  <h4 className="mb-0 counter">
                    {isLoading ? (
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : isError ? (
                      "0"
                    ) : (
                      data.total_products
                    )}
                    <a
                      href="/productsaddorupdate"
                      className="badge badge-light-secondary grow"
                    >
                      ADD NEW
                    </a>
                  </h4>
                </div>

                <div className="align-self-center text-center">
                  <i className="ri-chat-3-line"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* TOTAL CUSTOMERS */}
        <div className="col-sm-6 col-xxl-3 col-lg-6">
          <div
            className="main-tiles border-5 card-hover border-0 card o-hidden"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/orders")}
          >
            <div className="custome-4-bg b-r-4 card-body">
              <div className="media static-top-widget">
                <div className="media-body p-0">
                  <span className="m-0">Total Customers</span>
                  <h4 className="mb-0 counter">
                    {isLoading ? (
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : isError ? (
                      "0"
                    ) : (
                      data.total_customers
                    )}
                    <TrendingDown size={8.5} />
                  </h4>
                </div>

                <div className="align-self-center text-center">
                  <i className="ri-user-add-line"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* TOTAL REVIEWS */}
        <div className="col-sm-6 col-xxl-3 col-lg-6">
          <div
            className="main-tiles border-5 border-0  card-hover card o-hidden"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/VendorReview")}
          >
            <div className="custome-1-bg b-r-4 card-body">
              <div className="media align-items-center static-top-widget">
                <div className="media-body p-0">
                  <span className="m-0">Total Reviews</span>
                  <h4 className="mb-0 counter">
                    {isLoading ? (
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : isError ? (
                      "0"
                    ) : (
                      data.total_reviews
                    )}
                    <TrendingDown size={8.5} />
                  </h4>
                </div>
                <div className="align-self-center text-center">
                  <i className="ri-database-2-line"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- VendorTopCustomersChart start--> */}
        <div className="col-xl-6 col-md-12">
          <VendorTopCustomersChart topCustomers={data.top_customers} />
        </div>

        {/* <!-- VendorTopProductsChart start--> */}
        <div className="col-xl-6 col-md-12">
          <VendorTopProductsChart topProducts={data.top_products} />
        </div>
      </div>
    </div>
  );
}
